export const verificarCodTela = (
  arr: any[],
  cod_tela: number | number[],
): boolean => {
  const codTelas = Array.isArray(cod_tela) ? cod_tela : [cod_tela];
  return (arr || []).some((item) => codTelas.includes(item.cod_tela));
};
